import { render } from "./clamatoView.vue?vue&type=template&id=47ea9133"
import script from "./clamatoView.vue?vue&type=script&lang=js"
export * from "./clamatoView.vue?vue&type=script&lang=js"

import "./clamatoView.vue?vue&type=style&index=0&id=47ea9133&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__